<script>
  export let cases_since_trump_2;
  export let count;  // pre-computed count
</script>

<div class="feltron">{count.toLocaleString()}</div>
<div class="feltron-subtext"> {cases_since_trump_2 }</div>
<style lang="scss">
@use "@propublica/pp-frontend/rebrand-css/breakpoints-mixins-only" as bp;
.feltron {
    font-family: var(--p-fonts-hed);
    font-weight: bold;
    line-height: var(--p-line-height-2);
    color: var(--p-color-blue-03);
    font-size: 7.2rem;
    @include bp.breakpoint-min(sm) {
        font-size: 10rem;
    }
}
.feltron-subtext {
    font-family: var(--p-fonts-sans);
}
</style>
